<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="500px"
      overlay-opacity="0.9"
      @click:outside="close"
      persistent
      content-class="rounded-xl"
    >
      <v-card>
        <v-slide-x-reverse-transition group leave-absolute hide-on-leave>
          <div v-if="step === 1 && !!ticket" key="step-1">
            <v-card-title class="justify-center" key="step-1-title">
              <h4 class="word-keep-all">Transferir Ingresso</h4>
            </v-card-title>
            <v-card-text class="pb-2" key="step-1-text">
              <v-card
                v-if="contact"
                class="mb-2 pa-4 d-flex justify-space-between align-center"
                elevation="0"
                :outlined="!!contact"
              >
                <div class="flex-grow-1" style="display: grid">
                  <small class="text-overline d-block lh-1 mb-1">
                    Contato selecionado
                  </small>
                  <h6 class="mb-1 text-truncate">
                    {{ contact?.name }}
                  </h6>
                  <span>{{ contact?.tel.phone }}</span>
                </div>
                <v-btn class="flex-shrink-0" icon @click="resetContact">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card>

              <phone-input
                v-else
                :phone="whatsapp"
                @update:phone="(e) => (whatsapp = e)"
                :ddi="ddi"
                @update:ddi="(e) => (ddi = e)"
                @valid="(v) => (valid = v)"
                dense
                outlined
                label="WhatsApp do Destinatário"
                :disabled="loading"
              />

              <contact-selector
                :btnProps="{
                  small: true,
                  color: 'primary',
                  block: true,
                  text: true,
                }"
                btnLabel="Selecionar contato"
                @select="selectContact"
                @initSelect="resetContact"
                class="mb-4"
              />
              <v-alert
                v-if="ticket?.TicketBlock.concessionTicket"
                type="warning"
                text
              >
                Esse ingresso é uma meia entrada, o novo destinatário também
                deverá ser beneficiário do benefício.
                <template v-if="!ticket?.TicketBlock.concessionPreVerify">
                  <p class="mb-0">
                    É necessário que o novo destinatário esteja com o benefício
                    verificado antes de receber a transferência.
                  </p>
                  <v-btn
                    v-if="canShare"
                    small
                    class="mt-2"
                    @click="shareConcessionVerification"
                    color="warning"
                    block
                  >
                    Compartilhar link de verificação
                  </v-btn>
                </template>
              </v-alert>

              <v-alert
                v-if="ticket?.TicketShare.length > 0"
                type="warning"
                text
                dense
              >
                <b>Atenção!</b> Esse ingresso foi compartilhado antes. Relaizar
                a transferência irá cancelar os compartilhamentos anteriores.
              </v-alert>

              <v-alert
                v-if="ticket?.remainingTransfers == 1"
                type="warning"
                text
              >
                Esse ingresso só pode ser transferido
                <b> mais uma vez.</b> Verifique o número do WhatsApp antes de
                realizar a transferência.
              </v-alert>
              <v-alert v-else type="warning" text class="mb-0">
                Confira os dados do destinatário antes de compartilhar o
                ingresso.
              </v-alert>

              <v-alert
                type="error"
                v-if="error"
                class="mt-2 mb-0"
                border="left"
              >
                {{ error }}
              </v-alert>
            </v-card-text>
            <v-card-actions class="d-flex flex-column" key="step-1-actions">
              <v-btn
                color="primary"
                @click.prevent="transfer"
                block
                :disabled="(!valid && !contact) || loading"
                :loading="loading"
                class="mb-2"
              >
                Transferir
              </v-btn>
              <v-btn
                text
                @click="close"
                :disabled="loading"
                block
                class="ml-0"
              >
                Cancelar
              </v-btn>
            </v-card-actions>
          </div>
          <div v-if="step === 2" key="step-2">
            <v-card-text key="step-2-text">
              <div class="text-center pt-8">
                <v-avatar class="mb-4" size="60" color="success lighten-4">
                  <v-icon x-large color="success darken-2">mdi-check</v-icon>
                </v-avatar>
                <h4 class="mb-2 word-keep-all">
                  Ingresso transferido com sucesso!
                </h4>
                <p class="mb-2">
                  Uma notificação foi enviada para o número
                  <b class="font-weight-bold">{{ whatsapp }}</b>
                </p>
                <small class="d-block">
                  Esse ingresso não está mais disponível em sua conta.
                </small>
              </div>
            </v-card-text>
            <v-card-actions class="d-flex flex-column" key="step-2-actions">
              <v-btn
                color="primary"
                text
                @click="$router.push({ name: 'app.ticket' })"
                block
                class="ml-0"
              >
                Fechar
              </v-btn>
            </v-card-actions>
          </div>
        </v-slide-x-reverse-transition>
      </v-card>
    </v-dialog>

    <transfer-terms ref="terms" :whatsapp="whatsapp" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TICKET from "@/services/app/ticket";
import PhoneInput from "../../../global/PhoneInput.vue";
import TransferTerms from "./TransferTerms.vue";
import ContactSelector from "../../../global/ContactSelector.vue";
export default {
  components: {
    PhoneInput,
    TransferTerms,
    ContactSelector,
  },
  data: () => ({
    dialog: false,
    ticket: null,
    loading: false,
    valid: false,
    error: false,
    whatsapp: "",
    ddi: 55,
    step: 1,
    contact: null,
    canShare: !!window.navigator.share,
  }),
  methods: {
    open(ticket) {
      this.ticket = ticket;
      this.error = false;
      this.step = 1;
      this.whatsapp = "";
      this.ddi = 55;
      this.contact = null;
      this.dialog = true;
    },
    close() {
      if (this.loading) return;
      this.dialog = false;
      this.$emit("close");
      this.$nextTick(() => {
        this.whatsapp = "";
        this.ddi = 55;
        this.contact = null;
        this.error = false;
      });
    },
    async transfer() {
      try {
        this.loading = true;
        this.error = false;
        const acceptTerms = await this.$refs.terms.open(this.ticket);
        if (!acceptTerms) {
          this.loading = false;
          return;
        }
        await TICKET.transfer(this.ticket.id, {
          user: { phone: this.whatsapp, ddi: this.ddi },
        });
        this.step = 2;
      } catch (error) {
        this.error = error.message || "Erro ao transferir ingresso";
        this.loading = false;
      }
    },
    async shareConcessionVerification() {
      if (!this.canShare) return;
      await window.navigator.share({
        title: "Verificação de Meia Entrada",
        text: "Acesse o link para verificar o benefício de meia entrada",
        url: `${window.location.origin}/account/concession`,
      });
    },
    selectContact(contacts) {
      this.contact = contacts[0];
      this.whatsapp = this.contact.tel.phone;
      this.ddi = this.contact.tel.ddi;
    },
    resetContact() {
      this.contact = null;
      this.whatsapp = "";
      this.ddi = 55;
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  watch: {
    whatsapp() {
      this.error = false;
      this.contact = null;
    },
    step() {
      this.error = false;
    },
  },
  mounted() {
    this.$parent.$on("transfer", this.open);
  },
};
</script>

<style></style>
